import { useRouter } from "next/router";
import Modal from "../ui/modal";
import SearchPrompt from "../ui/search-prompt";
import SearchMenuItems from "../ui/search-menu-items";
import SearchModalInput from "../ui/search-modal-input";

const SearchModal = ({toggleModal, isOpen, children}) => {
  const router = useRouter();
  function handleSearch(e) {
    e.preventDefault();
    console.log("searching");
  }

  function handleCloseModal() {
    router.push("/");
  }

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal toggleModal={toggleModal} isOpen={isOpen} ignoreX additionalclasses='!pb-[23px] !px-[10px] !w-[837px] !bg-white-50 dark:!bg-white-dark-50' childrenClasses='!px-0'>
          <SearchModalInput/>
          <div className="h-[2px] custom-bg-grey-50 mb-[12px]"/>
          {children}
      </Modal>
    </>
  );
};

export default SearchModal;
